<template>
  <pt-notice-table class="pt-notice-table__withData" @getTableData="getTableData" :tableLabels="tableLabels" :pageSize="pageSize" :tableData="tableData"
  :total-number="totalNumber" :loading="loading">
      <slot/>
  </pt-notice-table>
</template>

<script>
import PtNoticeTable from './index'
export default {
  name: 'pt-notice-table__withData',
  components: {
    'pt-notice-table': PtNoticeTable
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      loading: false
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        message: {},
        pageableParam: {
          page: page,
          size: this.pageSize
        }
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getNoticeList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
        this.loading = false
      }).catch(err => {
        this.$message.error(err || '获取消息列表失败')
        this.loading = false
      })
    }
  }
}
</script>
